import Swal from 'sweetalert2';
import { modalSaveReport } from '../../modules/modalSaveReport.js';
import { closeModal } from '../../modules/modal.js';

export const hours = () => {
  const $form = document.querySelector('form');
  const $modal = $('#modal-save');
  const $inputHour = document.querySelectorAll('.js-form-hour');

  modalSaveReport(validateFields);

  $form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (validateFields()) e.target.submit();
  });

  function validateFields() {
    let isValid = true;
    let error;

    $inputHour.forEach(el => {
      let val = el.value.split(':');

      if (el.value.length <= 4) {
        error = 'Preencha os campos conforme o formato "hh:mm".';
        isValid = false;
      }

      if (val[1] >= 60) {
        error = 'Minutos inválidos';
        isValid = false;
      }
    });

    if (error) {
      Swal.fire('Atenção', error, 'error');
    }

    if (!isValid && $modal.length) closeModal('#modal-save');

    return isValid;
  }
};
